<script>
  export let menu = [];
  export let frame = undefined;
  
  function go(href) {
    if (frame == undefined) return;
    frame.contentWindow.location.href = href;
  }
</script>
<div class='hidden-print' id='sidebar-menu'>
<menu class='p-0'>
<ul class='nav nav-pills side-menu'>
{#each menu as {href, target, active, actions, title }, i}
<li class='nav-item'>
<a class:active='{active}' class='nav-link' href='{href}' on:click|preventDefault='{() => go(href)}' target='{target}'>
{title}
{#if actions}
{#each actions as a }
<a class='action' href='{a.href}' on:click|preventDefault='{() => go(a.href)}' target='{a.target}' title='{a.title}'>
{#if a.icon}
<i class='fa fa-{a.icon}'></i>
{:else}{a.title}{/if}
</a>
{/each}
{/if}
</a>
</li>
{/each}
</ul>
</menu>
</div>
